import { selectTenantName } from "features/user/userSlice";
import { useSelector } from "react-redux";
import { useGetClientsWithConfigsQuery } from "../../../features/clients/clientConfigSlice";
import { useGetLotsQuery } from "../../../features/lots/lotSlice";
import { getLotsWithTenantText } from "../../../features/lots/lotUtil";
import DropdownFilter from "../../DropdownFilter";

export default function LotsDropdown({
    title,
    identifier,
    onSelect,
    showEmpty,
    clientId,
    value,
    multiple,
    ownedByTenant,
    required,
    classStyles,
    newLots = [],
    filteredLots = null,
    withTypeAhead = false,
}) {
    const tenantName = useSelector(selectTenantName);

    let { data: clientsWithConfigs, error: error, isLoading: isLoading } = useGetClientsWithConfigsQuery(null);
    let { data: getLots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    const clientsConfigs = clientsWithConfigs?.find(c => c.id == clientId);
    let lots = clientsConfigs?.clientLots.length > 0 ? getLots?.filter(lot => clientsConfigs?.clientLots?.find(l => l.lotId == lot.id)) : getLots;

    lots = filteredLots !== null ? clientId > 0 ? filteredLots.filter(lot => lots?.find(l => l.id == lot.id)) : filteredLots : ownedByTenant ? lots?.filter(lot => lot.ownedByTenant) : lots;

    lots = (lots && newLots) ? [...lots, ...newLots] : lots;

    const lotOptions = getLotsWithTenantText(lots, tenantName) ?? [];

    return (
        <DropdownFilter
            title={title}
            identifier={identifier}
            values={lotOptions}
            onSelect={onSelect}
            value={value}
            showEmpty={showEmpty}
            multiple={multiple}
            required={required}
            classStyles={classStyles}
            withTypeAhead={withTypeAhead}
        />
    )
}